import { styled } from '@mui/material';
import { TextFieldElement } from 'react-hook-form-mui';
import { palette } from 'view/themes/palette';

export const Input = styled(TextFieldElement)<{ marginbottom: number; subLabel: any; label: any }>(
  ({ marginbottom, subLabel, label, theme }) => {
    return {
      marginBottom: `${marginbottom}px`,
      marginTop: subLabel ? '20px' : '0',

      '.MuiFormHelperText-root': {
        '&.Mui-error': {
          marginTop: '3px',
          color: palette.alerts.error,
        },
      },

      '.MuiFormLabel-root': {
        color: palette.text.header,
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '21px',
        top: subLabel ? '-20px' : '0',
        transform: 'scale(1)',
        marginBottom: subLabel ? '0' : '7px',

        '&.Mui-focused': {
          color: palette.text.header,
        },

        '&.Mui-error': {
          color: palette.alerts.error,
        },

        '.subLabel': {
          color: palette.unknown.sub_title_grey,
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',

          [theme.breakpoints.down('tablet')]: {
            fontSize: '10px',
          },
        },
      },

      '.MuiInputBase-root': {
        minHeight: '40px',
        color: palette.text.body,
        border: `1px solid ${palette.border.default}`,
        borderRadius: '8px',
        padding: '8px 12px',
        marginTop: label ? '28px' : '0px',

        '&::after, &::before': {
          display: 'none',
          border: 'none',
          outline: 'none',
        },

        '&:hover': {
          borderColor: palette.hover.brand,
        },

        '&:active': {
          borderColor: palette.primary.purple500,
        },

        '&.Mui-focused': {
          borderColor: palette.primary.purple500,
        },

        '&.Mui-error': {
          borderColor: palette.alerts.error,
        },
      },
    };
  }
);
